import React from 'react';

import { Box, Paper, Stack, Typography } from '@mui/material';

import { AVAILABILITY, ONLINE_PURCHASE } from '~/consts/schedule';

import { formatDateSlashesWithClockInSydney } from '~/services/TimeService';

import { scheduleForType } from '~/utils/scheduleForType';

import type { BrandSchedule } from './types';

interface DateRangeBoxProps {
  title: string;
  start?: string;
  end?: string;
}

function DateRangeBox({ title, start, end }: DateRangeBoxProps) {
  return (
    <Paper variant="outlined" sx={{ p: 2, flex: 1 }}>
      <Typography fontWeight={700} gutterBottom variant="subtitle2">
        {title}
      </Typography>
      <Stack alignItems="center" direction="row" spacing={2}>
        <Box>
          <Typography color="text.secondary" variant="caption">
            Start (Australia/Sydney)
          </Typography>
          <Typography variant="body2">{start ? formatDateSlashesWithClockInSydney(start) : '—'}</Typography>
        </Box>
        <Typography color="text.secondary">→</Typography>
        <Box>
          <Typography color="text.secondary" variant="caption">
            End (Australia/Sydney)
          </Typography>
          <Typography variant="body2">{end ? formatDateSlashesWithClockInSydney(end) : '—'}</Typography>
        </Box>
      </Stack>
    </Paper>
  );
}

interface Props {
  brandSchedules: Array<BrandSchedule>;
}

export default function ImportedSalesforceDatesSection({ brandSchedules }: Props) {
  const bookByStart = scheduleForType(brandSchedules, AVAILABILITY, 'start');
  const bookByEnd = scheduleForType(brandSchedules, AVAILABILITY, 'end');
  const offlineStart = scheduleForType(brandSchedules, ONLINE_PURCHASE, 'start');
  const offlineEnd = scheduleForType(brandSchedules, ONLINE_PURCHASE, 'end');

  return (
    <Paper variant="outlined" sx={{ p: 3 }}>
      <Typography fontWeight={700} sx={{ mb: 2 }} variant="subtitle1">
        Imported Salesforce Dates
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <DateRangeBox end={bookByEnd} start={bookByStart} title="Book By Dates" />
        <DateRangeBox end={offlineEnd} start={offlineStart} title="Available Offline" />
      </Stack>
    </Paper>
  );
}
